export default __webpack_public_path__ + "static/media/alert.576a1e4a.svg";